function getSquigglePaths() {
  return Array.prototype.slice.call(document.querySelectorAll('.home-approach-squiggle__path'));
}

function primePath(path) {
  var length = typeof path.getTotalLength === 'function' ? path.getTotalLength() : 0;

  if (!length || !isFinite(length)) {
    return 0;
  }

  path.style.strokeDasharray = String(length);
  path.style.strokeDashoffset = String(length);
  path.style.transition = 'none';

  return length;
}

function playPath(path, length, durationMs, delayMs) {
  window.setTimeout(function startPathDraw() {
    path.style.transition = 'stroke-dashoffset ' + durationMs + 'ms linear';
    path.style.strokeDashoffset = '0';
  }, delayMs);
}

export function initializeOurApproachSquiggleOnHeroEnd() {
  if (typeof window === 'undefined') {
    return function noop() {};
  }

  var squiggleElement = document.querySelector('.home-approach-squiggle');

  if (!squiggleElement) {
    return function noop() {};
  }

  var paths = getSquigglePaths();

  if (!paths.length) {
    return function noop() {};
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    squiggleElement.classList.remove('is-hidden-until-draw');

    paths.forEach(function showStaticPath(path) {
      path.style.transition = 'none';
      path.style.strokeDasharray = 'none';
      path.style.strokeDashoffset = '0';
    });

    return function noop() {};
  }

  var lengths = paths.map(primePath);
  var hasPlayed = false;

  function resetAnimation() {
    hasPlayed = false;
    squiggleElement.classList.add('is-hidden-until-draw');

    paths.forEach(function resetPath(path, index) {
      var length = lengths[index];

      if (!length) {
        return;
      }

      path.style.transition = 'none';
      path.style.strokeDashoffset = String(length);
    });
  }

  function playAnimation() {
    if (hasPlayed) {
      return;
    }

    hasPlayed = true;
    squiggleElement.classList.remove('is-hidden-until-draw');

    var totalLength = lengths.reduce(function sum(acc, value) {
      return acc + value;
    }, 0);

    if (!totalLength) {
      return;
    }

    var totalDurationMs = 2800;
    var minDurationMs = 900;
    var delayMs = 0;

    paths.forEach(function animatePath(path, index) {
      var length = lengths[index];

      if (!length) {
        return;
      }

      var durationMs = Math.max(minDurationMs, Math.round((length / totalLength) * totalDurationMs));
      playPath(path, length, durationMs, delayMs);
      delayMs += durationMs;
    });
  }

  window.addEventListener('rs:home-hero-takeover-end', playAnimation);
  window.addEventListener('rs:home-hero-takeover-reset', resetAnimation);

  return function cleanupOurApproachSquiggleOnHeroEnd() {
    window.removeEventListener('rs:home-hero-takeover-end', playAnimation);
    window.removeEventListener('rs:home-hero-takeover-reset', resetAnimation);
  };
}
